"use client";

/** Monochrome sun / moon silhouettes (structure only — no emoji colour). */
export function DashThemeGlyph({ variant }: { variant: "moon" | "sun" }) {
  if (variant === "moon") {
    return (
      <svg className="ed-dash-theme-glyph" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden>
        <path fill="currentColor" d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
      </svg>
    );
  }
  return (
    <svg className="ed-dash-theme-glyph" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.6" />
      <path
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        d="M12 2.25v2.2M12 19.55v2.2M4.46 4.46l1.56 1.56M17.98 17.98l1.56 1.56M2.25 12h2.2M19.55 12h2.2M4.46 19.54l1.56-1.56M17.98 6.02l1.56-1.56"
      />
    </svg>
  );
}

type Props = {
  isDarkMode: boolean;
  onToggle: () => void;
  /** Optional — dashboard tour anchor */
  dataTour?: string;
};

/** Same iOS-style control as the dashboard header — use everywhere for consistent light/dark toggling. */
export function ThemeToggleIos({ isDarkMode, onToggle, dataTour }: Props) {
  return (
    <button
      type="button"
      className="ed-dash-header-theme-ios"
      {...(dataTour ? { "data-tour": dataTour } : {})}
      onClick={onToggle}
      aria-pressed={isDarkMode}
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
      title={isDarkMode ? "Light appearance" : "Dark appearance"}
    >
      <span className="ed-dash-header-theme-ios__track" aria-hidden />
      <span className={`ed-dash-header-theme-ios__thumb${isDarkMode ? " ed-dash-header-theme-ios__thumb--dark" : ""}`}>
        {isDarkMode ? <DashThemeGlyph variant="moon" /> : <DashThemeGlyph variant="sun" />}
      </span>
    </button>
  );
}
